<template>
  <div style="width: 100%;height: 100%">
    <el-row type="flex" class="row-bg" justify="end" style="width: 100%; flex-wrap: wrap;">
      <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary" @click="preview" v-show="printStatus === 1">
        打印预览
      </el-button>
      <el-button size="small" style="margin-right: 20px; margin-top: 30px" type="primary" @click="websitePricePrint" v-show="fun_dic[100030110]">
        对标网站价格打印
      </el-button>
    </el-row>
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>供应商</span>：{{ data[0].SUPPLIER_NAME }}</li>
          <li><span>项目点</span>：{{ data[0].PROJECT_NAME }}</li>
          <li><span>项目点地址</span>：{{ data[0].PROJECT_ADDRESS }}</li>
          <li><span>送货日期</span>：{{ data[0].SEND_DAY }}</li>
          <li><span>订购总金额</span>：{{ data[0].TOTAL_SUPPLIER_FEE }}</li>
          <li><span>订单备注</span>：{{ data[0].ORDER_COMMENT }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>制单人</span>：{{ managername }}</li>
          <li><span>档口</span>：{{ data[0].DK_NAME }}</li>
          <li><span>项目点电话</span>：{{ data[0].PROJECT_TELPHONE }}</li>
          <li><span>订单编号</span>：{{ data[0].ORDER_CODE }}</li>
          <li><span>实收总金额</span>：{{ data[0].REAL_TOTAL_SUPPLIER_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-button style="margin-bottom: 20px" type="primary" @click="downloadAllBatchReport">批量下载批次报告</el-button>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.NEED_COUNT" @change="setActualNumber(scope.row)" v-if="fun_dic[100030105]">
              </el-input>
              <span v-else>{{ scope.row.NEED_COUNT }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="SUPPLIER_REAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="CATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column fixed="right" label="操作" v-if="confirmFlag == 2 || confirmFlag == 3">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-show="fun_dic[100030102]">修改</el-button><br>
              <el-button type="text" v-if="confirmFlag == 2" @click="openAllEdit(scope.row)">修改全部</el-button><br>
              <!-- 亦芙德专用 -->
              <el-button type="text" size="small" icon="el-icon-download" @click="downloadBatchReport(scope.row)"
                :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间:</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="updateOrderStatus" style="margin-top: 20px;float: right" type="primary" size="small"
          v-if="(confirmFlag == 1 && orderStatus == 6) || confirmFlag == 2">
          确认订单
        </el-button>
        <el-button @click="updateSendCont" style="margin-top: 20px;float: right" type="primary" size="small" v-if="confirmFlag == 3"
          v-show="fun_dic[100030109]">
          更新送货数量(更新为订购)
        </el-button>
        <el-button v-show="fun_dic[100030105]" @click="batchUpdateSendCont" style="margin-top: 20px; margin-right: 20px;float: right" type="primary"
          size="small">
          批量修改送货数量
        </el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
    </el-row>
    <!-- 待项目点确认订单修改产品送货数量 -->
    <el-dialog title="修改产品" center :visible.sync="editFormVisible" width="600px">
      <el-form :model="editForm" ref="editForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ name }}</span>
        </el-form-item>
        <el-form-item label="送货数量：" :label-width="formLabelWidth">
          <el-input v-model="editForm.NEED_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitEdit" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改全部信息 -->
    <el-dialog title="修改全部信息" center :visible.sync="editAllFormVisible" width="600px">
      <el-form :model="editAllForm" ref="editAllForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ Editname }}</span>
        </el-form-item>
        <el-form-item label="采购价：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.BUY_PRICE" @change="countPrice" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="报损后单价：" :label-width="formLabelWidth">
          <span> {{ editAllForm.WPRICE }}</span>
        </el-form-item>
        <el-form-item label="销售价：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.REAL_PRICE" :disabled="isisdisabled"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input v-model="editAllForm.PRODUCT_COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="submitEditAll" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印显示送货数量还是订购数量 -->
    <el-dialog title="打印项" center :visible.sync="printSetFormVisible" width="600px">
      <el-form>
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-radio v-model="printRadio" label="0">订购数量</el-radio>
          <el-radio v-model="printRadio" label="1">送货数量</el-radio>
        </el-form-item>
        <el-form-item label="单据类型：" :label-width="formLabelWidth">
          <el-radio v-model="docTypeRadio" label="0">长单子</el-radio>
          <el-radio v-model="docTypeRadio" label="1">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrint">打印</el-button>
      </div>
    </el-dialog>
    <el-dialog title="打印预览" center :visible.sync="productionDateOnlineDialog" width="600px" @close="cancelPreviewPrint">
      <el-form :model="productionDateOnlineForm" ref="productionDateOnlineForm">
        <el-form-item label="生产日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="productionDateOnlineForm.PRODUCTION_DATE" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable
            style="width: 100% !important;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="productionDateOnlineDialog = false">取 消</el-button>
        <el-button @click="submutPreview">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  confirmOrderFun, orderConfirmDetailFun, updatesendCountFun, updateNewDetailFun_Limit, priceCountFun, updateOrderFun, downloadOrderBatchReportFun,
} from 'api/sellOrder';
import { getActionFun } from 'api/login';
import bus from '@/assets/common/bus';
import util from '../../assets/common/util';
import http from '@/assets/common/http';
import { downloadBatchReport } from '@/assets/api/shopOrderManage';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['websitePricePrint', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail', 'OrderConfirmList'],
      toName: ['websitePricePrint', 'sellOrderPrint', 'sellOrderCustomPrintDetail', 'toBeConfirmePrintDetail'],
      managername: sessionStorage.getItem('name'),
      submitStatus: sessionStorage.getItem('submitStatus'),
      status: sessionStorage.getItem('orderStatus'),
      tableData: [],
      data: [{
        SUPPLIER_NAME: '',
        PROJECT_ADDRESS: '',
        ORDER_CODE: '',
        PROJECT_NAME: '',
        SEND_DAY: '',
        PROJECT_TELPHONE: '',
        DK_NAME: '',
      }],
      printStatus: '',
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
      checkData: [],
      statusFlag: 0,
      companyID: Number(sessionStorage.getItem('tcId')),
      name: '',
      loading: false,
      confirmFlag: sessionStorage.getItem('confirmFlag'), // 1表示待供应商确认，2自录订单确认，3待项目点确认,
      printSetFormVisible: false,
      printRadio: '0',
      docTypeRadio: '0',
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      isisdisabled: false,
      orderStatus: 0,
      submitCount: 0,
      PAGE_ID: '1000301', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100030102: 0, 100030105: 0, 100030109: 0, 100030110: 0,
      },
      productionDateOnlineDialog: false,
      productionDateOnlineForm: {
        PRODUCTION_DATE: '',
      },
    };
  },

  methods: {
    // 改变实收数量触发
    setActualNumber(row) {
      if (this.$util.JudgmentUnit(row.TYPE_UNIT) ? !validation.数量正数0验证(row.NEED_COUNT) : !validation.数量整数正数0验证(row.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        return false;
      }
      this.submitCount = Number(row.NEED_COUNT);
    },
    // 改变表格字体颜色
    tableRowClassName({ row }) {
      if (Number(row.PRODUCT_COUNT) !== Number(row.REAL_COUNT)) {
        return 'warning-row';
      }
      return '';
    },
    // --------------------------拉取数据
    queryOrderDetailListData() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      orderConfirmDetailFun(params).then((result) => {
        this.tableData = result.length > 0 ? result[0].DETAIL.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) })) : [];
        this.tableData.forEach((element) => {
          if (Number(element.NEED_COUNT) == -1 || Number(element.NEED_COUNT) == -2) {
            element.NEED_COUNT = element.PRODUCT_COUNT;
          }
        });
        this.data = result.length > 0 ? result[0].TITLE : [];
        this.checkData = result.length > 0 ? result[0].OR[0].DATA : [];
        this.statusFlag = result.length > 0 ? result[0].OR[0].RN : 0;
        this.printStatus = result[0].PRINT_FLAG;
        this.orderStatus = result[0].TITLE[0].STATUS;
        if (result[0].TITLE[0].AGENT) {
          sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
        } else {
          sessionStorage.setItem('AGENT', 0);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 更新送货数量
    updateSendCont() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      updatesendCountFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editForm = row;
      this.name = row.PRODUCT_NAME;
      this.ORDER_DETAIL_ID = row.ORDER_DETAIL_ID;
    },
    // 修改全部
    openAllEdit(row) {
      this.editAllFormVisible = true;
      this.editAllForm = { ...row };
      this.Editname = row.PRODUCT_NAME;
    },
    // 全部提交
    submitEditAll() {
      if (util.JudgmentUnit(this.editAllForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editAllForm.PRODUCT_COUNT) : !validation.数量整数正数0验证(this.editAllForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        return false;
      }
      if (!validation.价格正数0验证(this.editAllForm.REAL_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_DETAIL_ID: this.editAllForm.ORDER_DETAIL_ID,
        NEW_COUNT: Number(this.editAllForm.PRODUCT_COUNT),
        MODIFY_FLAG: 1,
        PRICE: this.editAllForm.REAL_PRICE,
        PRODUCT_COMMENT: this.editAllForm.PRODUCT_COMMENT,
        SUPPLIER_ID: this.data[0].SUPPLIER_ID,
        PRODUCT_CODE: this.editAllForm.PRODUCT_CODE,
      };
      this.loading = true;
      updateOrderFun(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editAllFormVisible = false;
        this.queryOrderDetailListData();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 全部关闭
    closeAll() {
      this.editAllFormVisible = false;
    },
    countPrice() {
      if (validation.价格正数验证(this.editAllForm.BUY_PRICE)) {
        const params = {
          PRICE: this.editAllForm.BUY_PRICE,
          CATALOG_ID: this.editAllForm.CATALOG_ID,
        };
        priceCountFun(params).then((result) => {
          this.editAllForm.REAL_PRICE = result[0];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入正数的采购价', type: 'warning' });
        this.editAllForm.BUY_PRICE = '';
      }
    },
    submitEdit() {
      if (util.JudgmentUnit(this.editForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editForm.NEED_COUNT) : !validation.数量整数正数0验证(this.editForm.NEED_COUNT)) {
        this.$message.show({ text: '请输入正确的送货数量', type: 'warning' });
        return false;
      }
      const params = {
        DETAIL_ID: this.ORDER_DETAIL_ID,
        NEED_COUNT: Number(this.editForm.NEED_COUNT),
        TC_ID: Number(this.data[0].TC_ID),
      };
      this.loading = true;
      updateNewDetailFun_Limit(params).then((result) => {
        this.loading = false;
        this.$message.show({ text: '操作成功', type: 'success' });
        this.editFormVisible = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
        this.queryOrderDetailListData();
      });
    },
    close() {
      this.editFormVisible = false;
    },
    // 批量修改送货数量
    async batchUpdateSendCont() {
      let countFlag = 0;
      this.tableData.forEach((ele) => {
        const reg = /\d/;
        if (!reg.test(ele.NEED_COUNT)) {
          countFlag = 1;
        }
        if (!util.JudgmentUnit(ele.TYPE_UNIT)) { // 如果不是
          const beInter = (ele.NEED_COUNT % 1 === 0);
          if (beInter == false) {
            countFlag = 1;
          }
        }
      });
      if (countFlag == 1) {
        this.$message.show({ text: '请输入送货数量，且单位不是KG的，只能输入整数', type: 'error' });
        return;
      }
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let flag = 0;
      this.tableData.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10009',
          OTYPE: 48,
          DETAIL_ID: item.ORDER_DETAIL_ID,
          NEED_COUNT: Number(item.NEED_COUNT),
          TC_ID: Number(this.data[0].TC_ID),
        });
      });
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await http.post(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        flag = 2;
      }
      if (flag == 0) {
        this.queryOrderDetailListData();
        this.$message.show({ text: '批量修改送货数量成功', type: 'success' });
      } else {
        let errText = '';
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
        this.queryOrderDetailListData();
      }
    },
    updateOrderStatus() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
      };
      confirmOrderFun(params).then((result) => {
        this.$message.show({ text: '订单确认成功', type: 'success' });
        this.$router.push({ name: 'OrderConfirmList' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -------------------------打印
    preview() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        TC_ID: this.data[0].TC_ID,
        IS_SUPPLIER_CLIENT: 0,
      };
      http.post(params).then((result) => {
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          if (Number(sessionStorage.getItem('orderPrintStatus')) == 1) {
            this.$router.push({ name: 'toBeConfirmePrintDetail' });
            sessionStorage.setItem('TEM_TCID', this.data[0].TC_ID);
          } else {
            if (result[0].TEMPLATE_CONTENT && result[0].TEMPLATE_CONTENT[0] && result[0].TEMPLATE_CONTENT[0].tableSet.includes('生产日期(线上填写)')) this.productionDateOnline = true;
            else this.submutPreview();
          }
        } else {
          this.printSetFormVisible = true;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    cancelPreviewPrint() {
      this.$refs.productionDateOnlineForm.resetFields();
    },
    submutPreview() {
      sessionStorage.setItem('未签收销售单打印 生产日期(线上填写)', this.productionDateOnlineForm.PRODUCTION_DATE);
      sessionStorage.setItem('TEM_TCID', this.data[0].TC_ID);
      this.$router.push({ name: 'sellOrderCustomPrintDetail' });
    },
    submitPrint() {
      this.$router.push({ name: 'sellOrderPrint' });
      sessionStorage.setItem('countFlag', this.printRadio);
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadio);
      sessionStorage.setItem('printRealFlag', 0);
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    websitePricePrint() {
      const params = {
        SERVICE_ID: '10051',
        OTYPE: 11,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.$prompt('', '请输入乘算比例(%)', {
          confirmButtonText: '确定', cancelButtonText: '取消', inputValue: sessionStorage.getItem('websitePriceRate') ? sessionStorage.getItem('websitePriceRate') : '', center: true,
        }).then(({ value }) => {
          if (/(^([1-9]\d*)$)/.test(value)) {
            this.$router.push({ name: 'websitePricePrint' });
            sessionStorage.setItem('countFlag', 0); // 0表示打印订购数量,1表示打印送货数量
            sessionStorage.setItem('isShortDocFlag', 0);
            sessionStorage.setItem('printRealFlag', 0);
            sessionStorage.setItem('websitePriceRate', value);
          } else {
            this.$message.show({ text: '请输入正整数', type: 'warning' });
          }
        }).catch((e) => { });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    // 下载批次报告
    downloadBatchReport(row) {
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((res) => {
        if (res[0]) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        }
      });
    },
    downloadAllBatchReport() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      downloadOrderBatchReportFun(params).then((res) => {
        if (res.length) {
          this.$message.show({ text: '下载成功', type: 'success' });
          window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
        } else {
          this.$message.show({ text: '订单内所有商品未上传批次报告', type: 'warning' });
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待确认订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        // 控制是否可以自行修改价格
        if (Number(that.CAN_MODIFY_PRICE) === 1) {
          that.isisdisabled = false;
        } else {
          that.isisdisabled = true;
        }
        that.queryOrderDetailListData();
        that.queryBeforeFun();
      }
    });
  },
  destroyed() {
    bus.$emit('submit', this.tableData);
  },
};
</script>
<style scoped>
.el-table >>> .warning-row {
  color: rgb(245, 108, 108);
}

.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/confirmOrderDetail.vue